/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialPostCategoryResponse } from '../../models/editorial-post-category-response';

export interface GetPostCategoryDetail$Params {
  id: number;
}

export function getPostCategoryDetail(http: HttpClient, rootUrl: string, params: GetPostCategoryDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialPostCategoryResponse>> {
  const rb = new RequestBuilder(rootUrl, getPostCategoryDetail.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialPostCategoryResponse>;
    })
  );
}

getPostCategoryDetail.PATH = '/api/editorial/post-category/{id}';
